// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Homepage/wavelength.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-3-container {
    width: 100%;
    margin: auto;
    margin-bottom: var(--margin-bottom-mobile);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
}

.section-3-container>div p {
    margin: 0;
}

.section-3-top-line1 {
    width: 70%;
    margin: 0 auto;
    font-size: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
    font-weight: lighter;
}

.section-3-top-line2 {
    margin: 0;
    font-size: 3rem;
    text-align: center;
    font-weight: bolder;
}

.section-3-bottom {
    display: flex;
    width: 70%;
    margin: auto;
    font-size: var(--font-size1);
    justify-content: space-evenly;
    font-weight: 600;

    & div {
        width: 18%;

    }

    & hr {
        color: #0B63E5;
        border: 2px solid #0B63E5;
        margin: 2rem 0;
    }
}

.section-3-end {
    width: 70%;
    font-size: 20px;
    font-style: italic;
    text-align: center;
    margin: 2.5rem auto;
}

@media screen and (min-width:300px) and (max-width:490px) {
    .section-3-container {
        margin-bottom: var(--margin-bottom-mobile);
        background-image: none;
    }

    .section-3-top-line1 {
        width: 100%;
        font-size: 1rem;
        gap: 0.1rem;

        & img {
            width: 10%;
        }
    }

    .section-3-top-line2 {
        font-size: 1rem;
    }

    .section-3-bottom {
        display: grid;
        gap: 1rem;
        grid-template-columns: repeat(2, 1fr);
        margin-top: 3rem;
    }

    .section-3-bottom div {
        width: 90%;
        font-size: 0.75rem;

        & img {
            width: 30%;
        }

        & hr {
            margin: 1rem 0;
        }
    }

    .section-3-end {
        font-size: 14px;
    }
}

@media screen and (min-width:601px) and (max-width:840px) {
    .section-3-container {
        margin-bottom: 3rem;
        background-image: none;
    }

    .section-3-top-line1 {
        font-size: 1.5rem;
        gap: 0.2rem;

        & img {
            width: 15%;
        }
    }

    .section-3-top-line2 {
        font-size: 1.5rem;
    }

    .section-3-bottom {
        display: grid;
        gap: 1rem;
        grid-template-columns: repeat(2, 1fr);
        margin-top: 3rem;
    }

    .section-3-bottom div {
        width: 90%;
        font-size: 1rem;

        & img {
            width: 30%;
        }

        & hr {
            margin: 1rem 0;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section3.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,yDAA6D;IAC7D,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;;IAEhB;QACI,UAAU;;IAEd;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,cAAc;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,0CAA0C;QAC1C,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,WAAW;;QAEX;YACI,UAAU;QACd;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,kBAAkB;;QAElB;YACI,UAAU;QACd;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,WAAW;;QAEX;YACI,UAAU;QACd;IACJ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;;QAEf;YACI,UAAU;QACd;;QAEA;YACI,cAAc;QAClB;IACJ;AACJ","sourcesContent":[".section-3-container {\r\n    width: 100%;\r\n    margin: auto;\r\n    margin-bottom: var(--margin-bottom-mobile);\r\n    background-image: url('../../assets/Homepage/wavelength.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.section-3-container>div p {\r\n    margin: 0;\r\n}\r\n\r\n.section-3-top-line1 {\r\n    width: 70%;\r\n    margin: 0 auto;\r\n    font-size: 3rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 0.2rem;\r\n    font-weight: lighter;\r\n}\r\n\r\n.section-3-top-line2 {\r\n    margin: 0;\r\n    font-size: 3rem;\r\n    text-align: center;\r\n    font-weight: bolder;\r\n}\r\n\r\n.section-3-bottom {\r\n    display: flex;\r\n    width: 70%;\r\n    margin: auto;\r\n    font-size: var(--font-size1);\r\n    justify-content: space-evenly;\r\n    font-weight: 600;\r\n\r\n    & div {\r\n        width: 18%;\r\n\r\n    }\r\n\r\n    & hr {\r\n        color: #0B63E5;\r\n        border: 2px solid #0B63E5;\r\n        margin: 2rem 0;\r\n    }\r\n}\r\n\r\n.section-3-end {\r\n    width: 70%;\r\n    font-size: 20px;\r\n    font-style: italic;\r\n    text-align: center;\r\n    margin: 2.5rem auto;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .section-3-container {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n        background-image: none;\r\n    }\r\n\r\n    .section-3-top-line1 {\r\n        width: 100%;\r\n        font-size: 1rem;\r\n        gap: 0.1rem;\r\n\r\n        & img {\r\n            width: 10%;\r\n        }\r\n    }\r\n\r\n    .section-3-top-line2 {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .section-3-bottom {\r\n        display: grid;\r\n        gap: 1rem;\r\n        grid-template-columns: repeat(2, 1fr);\r\n        margin-top: 3rem;\r\n    }\r\n\r\n    .section-3-bottom div {\r\n        width: 90%;\r\n        font-size: 0.75rem;\r\n\r\n        & img {\r\n            width: 30%;\r\n        }\r\n\r\n        & hr {\r\n            margin: 1rem 0;\r\n        }\r\n    }\r\n\r\n    .section-3-end {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .section-3-container {\r\n        margin-bottom: 3rem;\r\n        background-image: none;\r\n    }\r\n\r\n    .section-3-top-line1 {\r\n        font-size: 1.5rem;\r\n        gap: 0.2rem;\r\n\r\n        & img {\r\n            width: 15%;\r\n        }\r\n    }\r\n\r\n    .section-3-top-line2 {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .section-3-bottom {\r\n        display: grid;\r\n        gap: 1rem;\r\n        grid-template-columns: repeat(2, 1fr);\r\n        margin-top: 3rem;\r\n    }\r\n\r\n    .section-3-bottom div {\r\n        width: 90%;\r\n        font-size: 1rem;\r\n\r\n        & img {\r\n            width: 30%;\r\n        }\r\n\r\n        & hr {\r\n            margin: 1rem 0;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
